<!-- 密码设置结果... -->
<template>
  <section :class="['result-body', displayLayout, isNewClass]">
    <div :class="['main-content', 'flex-col-center', statusDesc]">
      <MBIcon
        defaultClass="colour"
        :name="status === 1 ? 'c-success-green' : 'c-Failed'"
        :size="isDesktop ? 80 : 200"
      />
      <p class="desc">{{ descText }}</p>
      <div class="footer" v-show="status === 0">
        <button @click="resetPassword">
          {{ $t('account.reset_password') }}
        </button>
      </div>
    </div>
  </section>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import MBIcon from '@/components/MBIcon'

  export default {
    name: 'setting-result',
    components: {
      MBIcon,
    },
    props: {
      configData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {}
    },
    computed: {
      ...mapState(['isDesktop']),
      ...mapGetters(['displayLayout', 'isNewClass']),
      descText() {
        let errTip = this.$t('apiErrorTips.default')
        let successTip = this.$t('account.pw_set_success')
        const { status, errcode, inFrozenState } = this.configData || {}
        if (this.configData && status === 1) {
          if (inFrozenState) {
            successTip = this.$t(`account.unfreeze_account`)
          }
        } else {
          if (inFrozenState) {
            errTip = this.$t(`account.verification_failed`)
          } else {
            errTip = this.$t(`apiErrorTips.${errcode}`)
          }
        }
        return this.status === 1 ? successTip : errTip
      },
      status() {
        return this.configData.status || 0 //0: 失败， 1：成功
      },
      statusDesc() {
        return this.status === 1 ? 'success' : 'error'
      },
    },
    mounted() {
      if (this.status === 0) return
      // 成功时通知父组件自动关闭弹窗
      this.$emit('jumpto', { type: 'close', value: this.status })
    },
    methods: {
      resetPassword() {
        this.$emit('jumpto', 'password-setting')
      },
    },
  }
</script>
<style scoped lang="scss">
  .result-body {
    width: 100%;
    height: 80%;
    .main-content {
      margin-top: 170px;
      margin-bottom: 90px;
      font-family: 'Roboto';
      .desc {
        text-align: center;
        font-weight: 500;
        font-size: 54px;
        line-height: 63px;
        margin: 65px 75px 75px;
      }
      .footer {
        width: 100%;
        padding: 0 90px;
        box-sizing: border-box;
        & > button {
          width: 100%;
          height: 132px;
          background: linear-gradient(114.2deg, #ff910f 15.3%, #ff450b 84.29%);
          border-radius: 100px;
          font-weight: 600;
          font-size: 48px;
          line-height: 64px;
          text-align: center;
          text-transform: uppercase;
          color: #ffffff;
          cursor: pointer;
        }
      }
    }

    &.desktop-layout {
      width: 100%;
      height: 80%;
      .main-content {
        margin-top: 69px;
        margin-bottom: 35px;
        .desc {
          font-weight: 800;
          font-size: 18px;
          line-height: 22px;
          margin: 23px 28px 28px;
          word-break: break-all;
        }
        .footer {
          width: 100%;
          padding: 0 30px;
          box-sizing: border-box;
          & > button {
            width: 100%;
            height: 48px;
            border-radius: 33px;
            font-size: 16.6px;
            line-height: 21px;
            cursor: pointer;
          }
        }
      }
    }
  }

  .result-body.is-new {
    .main-content .desc {
      font: 600 54px/74px 'Noto Sans';
      color: $white;
    }
  }
</style>
